module.exports = __webpack_public_path__ + "022d52268c2508058a6e80ea1fefbb33.pdf";